import { render, staticRenderFns } from "./SalonsFinance.vue?vue&type=template&id=0381186b"
import script from "./SalonsFinance.vue?vue&type=script&lang=ts"
export * from "./SalonsFinance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports